import { TextContentWidgetComponent } from './TextContentWidgetComponent';

export function TextContentWidgetComponentC(
  props: React.ComponentProps<typeof TextContentWidgetComponent>,
) {
  return <TextContentWidgetComponent {...props} />;
}
